import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-chart\"><g clip-path=\"url(#icon-chart_clip0_917_39070)\" fill=\"#fff\"><path d=\"M21 3H3c-1.1 0-2 .901-2 2.002v14.016C1 20.119 1.9 21 3 21h18c1.1 0 2-.881 2-1.982V5.002C23 3.901 22.1 3 21 3zm0 16.028H3V4.982h18v14.046z\" /><path d=\"M8 10H6v7h2v-7zM13 7h-2v10h2V7zM18 13h-2v4h2v-4z\" /></g><defs><clipPath id=\"icon-chart_clip0_917_39070\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol